import type { IconTypes } from '../../ui/react/src';

export enum ErrorCodes {
  CHKPY210090 = 'CHKPY210090'
}
export interface IErrorHandlerBilling {
  contentAssets: IconTypes;
  title: string;
  message: string;
  type: string; //info, redirect
  cta?: string;
  errorCode?: ErrorCodes | string;
  originError?: string;
  redirectUrl?: string;
  enableAutoRedirect?: boolean;
}

export interface IErrorResponse {
  statusCode?: number;
  path?: string;
  error: IErrorResponseError;
}

export interface IErrorResponseError {
  message?: string;
  type?: string;
  meta?: { [key: string]: string };
}
